import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en.json";
import translationBG from "./locales/bg.json";

const resources = {
  en: { translation: translationEN },
  bg: { translation: translationBG }
};

const storedLanguage = localStorage.getItem('selectedLanguage');

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLanguage || 'bg',
    fallbackLng: 'bg',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('selectedLanguage', lng);
});

export default i18n;
